import qs from 'qs';

import { axios } from 'lib';

export const getCompanies = async (type, searchTerm = '', includeInactive = true, includeShadow = true, website = false) => {
  const queryStringParams = qs.stringify({
    offset: 0,
    limit: 10,
    search: searchTerm,
    companytype: type,
    includeinactive: includeInactive,
    includeshadow: includeShadow,
  });

  let endpoint = `/api/companies`;
  if (website) {
    endpoint = `/website/companies`;
  }

  try {
    const { data } = await axios.get(`${endpoint}?${queryStringParams}`);
    return data;
  } catch (error) {}

  return { data: [] };
};
